<template>
    <app-data-table
        :fields="fields"
        :items="tableData"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="city.name" slot-scope="{ item }">{{ getLocalization(item) }}</template>

        <template slot="businessLines" slot-scope="{ item }">
            <div v-for="bl in item.business_lines" :key="bl.id" :title="bl.name">{{ bl.code }}</div>
        </template>

        <template slot="actions" slot-scope="{ item }">
            <div v-if="!item.deleted_at">
                <b-button size="sm" variant="primary" title="Administrar" @click="pickClient(item)">
                    <i class="fa fa-users"></i>
                </b-button>
                <b-button
                    v-if="userCan('manage-client-optional-modules')"
                    variant="secondary"
                    size="sm"
                    class="ml-1"
                    title="Configuración de módulos"
                    @click="configureClient(item)"
                >
                    <i class="fa fa-cog" aria-hidden="true"></i>
                </b-button>
                <b-button
                    variant="primary"
                    size="sm"
                    title="Actualizar"
                    @click="updateClient(item)"
                >
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                </b-button>
                <!-- <b-button
                    variant="primary"
                    size="sm"
                    title="Asignar Herramientas"
                    @click="assignTool(item)"
                >
                    <i class="fa fa-list-ol" aria-hidden="true"></i>
                </b-button> -->
                <b-button
                    variant="danger"
                    size="sm"
                    title="Deshabilitar"
                    @click="disableClient(item)"
                >
                    <i class="fa fa-ban" aria-hidden="true"></i>
                </b-button>
            </div>
            <div v-else>
                <b-button
                    size="sm"
                    variant="primary"
                    title="Habilitar"
                    @click="activateClient(item)"
                >
                    <i class="fa fa-check"></i> Activar
                </b-button>
            </div>
        </template>
    </app-data-table>
</template>
<script>
export default {
    data() {
        return {
            fields: [
                {
                    key: 'name',
                    label: 'Nombre',
                    filter: true,
                },
                {
                    key: 'city.name',
                    label: 'Ubicación',
                    filter: true,
                },
                {
                    key: 'client_type.name',
                    label: 'Tipo cliente',
                    filter: true,
                },
                {
                    key: 'identification_type.name',
                    label: 'Tipo documento',
                    filter: true,
                },
                {
                    key: 'document',
                    label: 'Documento',
                    filter: true,
                },
                {
                    key: 'address',
                    label: 'Dirección',
                    filter: true,
                },
                {
                    key: 'phone',
                    label: 'Teléfono',
                    filter: true,
                },
                {
                    key: 'email',
                    label: 'E-mail',
                    filter: true,
                },
                {
                    key: 'code',
                    label: 'Código',
                    filter: false,
                },
                {
                    key: 'account_executive.name',
                    label: 'Ejecutivo',
                    filter: true,
                },
                {
                    key: 'businessLines',
                    label: 'Lineas',
                },
                {
                    key: 'actions',
                    label: 'Acciones',
                },
            ],
        }
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        updateClient: {
            type: Function,
            required: true,
        },
        disableClient: {
            type: Function,
            required: true,
        },
        configureClient: {
            type: Function,
            required: true,
        },
        onChangePage: {
            type: Function,
            required: true,
        },
        assignTool: {
            type: Function,
            required: true,
        },
        pickClient: {
            type: Function,
            required: true,
        },
        activateClient: {
            type: Function,
            required: true,
        },
    },
    computed: {
        tableData() {
            if (!this.data || !this.data.data) return []

            return this.data.data.map(item => {
                const classes = item.deleted_at ? 'disabled' : ''
                const _rowDetails = false
                return { ...item, _rowDetails, classes }
            })
        },
    },
    methods: {
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
        getLocalization(client) {
            if (!client.city || !client.city.country) return ''
            return `${client.city.name} / ${client.city.country.code}`
        },
    },
}
</script>
<style>
.disabled {
    text-decoration: line-through;
    color: gray;
}
</style>